import { ApplicationInsights } from '@microsoft/applicationinsights-web';

/** Set REACT_APP_APPINSIGHTS_CONNECTION_STRING in your env (Azure Portal → App Insights → Connection string). */
let appInsights = null;

export function initializeAppInsights() {
  const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
  if (!connectionString) {
    return null;
  }

  const ai = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false,
    },
  });
  ai.loadAppInsights();
  appInsights = ai;
  return ai;
}

export function getAppInsights() {
  return appInsights;
}

export function trackEvent(name, properties) {
  appInsights?.trackEvent({ name, properties });
}

export function trackException(error, properties) {
  if (!appInsights) return;
  const exception = error instanceof Error ? error : new Error(String(error));
  appInsights.trackException({ exception, properties });
}
